(function(){
  const root=document.querySelector("[data-crack]"); if(!root) return;
  const $=s=>root.querySelector(s);
  const ID=root.dataset.mt;
  const DATA=(()=>{const b=atob(root.dataset.k),u=new Uint8Array(b.length);for(let i=0;i<b.length;i++)u[i]=b.charCodeAt(i);return JSON.parse(new TextDecoder().decode(u))})();
  const P=DATA.P.map(([n,nat,lg,tm,pos,y,d])=>({n,nat,lg,tm,pos,y,d}));
  const norm=s=>s.normalize("NFD").replace(/[̀-ͯ]/g,"").toLowerCase();
  const esc=s=>String(s).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
  const store={get(k){try{return JSON.parse(localStorage.getItem(k))}catch(e){return null}},set(k,v){try{localStorage.setItem(k,JSON.stringify(v))}catch(e){}}};
  const todayKey=new Intl.DateTimeFormat("en-CA",{timeZone:"Europe/Madrid",year:"numeric",month:"2-digit",day:"2-digit"}).format(new Date());
  const dayIdx=Math.max(0,Math.round((new Date(todayKey+"T12:00:00Z")-new Date(DATA.L+"T12:00:00Z"))/864e5));
  const KEY="crack-"+todayKey;
  const RM=window.matchMedia&&matchMedia("(prefers-reduced-motion: reduce)").matches;
  const REVEAL=RM?0:6*320+500;
  const q=$("[data-q]"), sugg=$("[data-sugg]"), modal=$("[data-modal]"), mbody=$("[data-mbody]");
  let mode="daily", target, state, fresh=false, revealing=false, opts=[], sel=0, lastFocus=null;

  $("[data-jornada]").textContent="Jornada "+(dayIdx+1);
  $("[data-date]").textContent=new Intl.DateTimeFormat("es-ES",{weekday:"long",day:"numeric",month:"long",timeZone:"Europe/Madrid"}).format(new Date());

  function load(){
    target=P[DATA.O[dayIdx%DATA.O.length]];
    const saved=store.get(KEY);
    state=(saved&&Array.isArray(saved.g))?saved:{g:[],done:false,won:false,claimed:false};
    state.g=state.g.filter(n=>P.some(p=>p.n===n));
    render();
  }
  function save(){ if(mode==="daily") store.set(KEY,state); }

  function showSugg(){
    const v=norm(q.value.trim()), used=new Set(state.g);
    opts=v?P.filter(p=>norm(p.n).includes(v)&&!used.has(p.n)).slice(0,7):[];
    sel=0;
    sugg.innerHTML=opts.map((p,i)=>`<li role="option" data-i="${i}" aria-selected="${i===sel}">${esc(p.n)}<small>${esc(p.tm)}</small></li>`).join("");
    sugg.hidden=!opts.length; q.setAttribute("aria-expanded",String(!!opts.length));
  }
  q.addEventListener("input",showSugg);
  q.addEventListener("keydown",e=>{
    if(sugg.hidden)return;
    if(e.key==="ArrowDown"||e.key==="ArrowUp"){e.preventDefault();sel=(sel+(e.key==="ArrowDown"?1:-1)+opts.length)%opts.length;[...sugg.children].forEach((li,i)=>li.setAttribute("aria-selected",i===sel))}
    if(e.key==="Enter"){e.preventDefault();pick(opts[sel])}
    if(e.key==="Escape"){sugg.hidden=true}
  });
  sugg.addEventListener("mousedown",e=>{const li=e.target.closest("li");if(li){e.preventDefault();pick(opts[+li.dataset.i])}});
  document.addEventListener("click",e=>{if(!e.target.closest(".crack__search"))sugg.hidden=true});

  function pick(p){
    if(!p||state.done||revealing)return;
    state.g.push(p.n); q.value=""; sugg.hidden=true;
    if(p.n===target.n){state.done=true;state.won=true}
    else if(state.g.length>=6){state.done=true}
    save(); fresh=true; revealing=true; render(); fresh=false; q.disabled=true;
    setTimeout(()=>{revealing=false;renderLights();q.disabled=state.done;if(state.done){renderResult();setTimeout(openModal,RM?300:900)}else q.focus()},REVEAL);
  }

  function compare(p){
    const t=target,c=[];
    c.push({l:"Nación",v:p.nat,s:p.nat===t.nat?"hit":"miss"});
    c.push({l:"Liga",v:p.lg,s:p.lg===t.lg?"hit":"miss"});
    c.push({l:"Equipo",v:p.tm,s:p.tm===t.tm?"hit":(p.lg===t.lg?"near":"miss")});
    c.push({l:"Posición",v:p.pos,s:p.pos===t.pos?"hit":"miss"});
    c.push({l:"Nacido",v:p.y+(p.y===t.y?"":(t.y>p.y?" ▲":" ▼")),s:p.y===t.y?"hit":(Math.abs(p.y-t.y)<=2?"near":"miss")});
    c.push({l:"Dorsal",v:p.d+(p.d===t.d?"":(t.d>p.d?" ▲":" ▼")),s:p.d===t.d?"hit":(Math.abs(p.d-t.d)<=3?"near":"miss")});
    return c;
  }
  function renderLights(){
    const shown=revealing?state.g.length-1:state.g.length, won=state.won&&!revealing;
    $("[data-lights]").innerHTML="Intentos "+[0,1,2,3,4,5].map(i=>`<i class="${i<shown?"used":""}${won&&i===shown-1?" won":""}"></i>`).join("");
  }
  function render(){
    renderLights();
    $("[data-guesses]").innerHTML=state.g.length?state.g.slice().reverse().map((n,ri)=>{
      const p=P.find(x=>x.n===n), num=state.g.length-ri, isNew=fresh&&ri===0;
      return `<article class="crack__guess${isNew?" fresh":""}"><div class="crack__gname">${esc(p.n)}<small>Intento ${num}/6</small></div><div class="crack__cells">${compare(p).map((c,k)=>`<div class="crack__cell ${c.s}" style="--i:${k}"><small>${c.l}</small><b>${esc(c.v)}</b></div>`).join("")}</div></article>`;
    }).join(""):`<div class="crack__empty">Aún no has tirado. Empieza con un jugador que conozcas bien: cada intento te da pistas para el siguiente.</div>`;
    q.disabled=state.done||revealing;
    q.placeholder=state.done?(mode==="daily"?"Vuelve mañana para un crack nuevo":"Partida terminada"):"Ej: Pedri, Haaland, Salah…";
    if(!revealing) renderResult();
  }
  function shareText(){
    const rows=state.g.map(n=>compare(P.find(x=>x.n===n)).map(c=>c.s==="hit"?"🟩":c.s==="near"?"🟧":"⬛").join("")).join("\n");
    return `El crack del día · Jornada ${dayIdx+1} · ${state.won?state.g.length:"X"}/6\n${rows}\n${location.origin}${location.pathname}`;
  }

  /* Camisetas relacionadas: búsqueda en vivo en la tienda */
  const nrm=s=>norm(String(s||""));
  function searchShop(qs){
    return fetch(`/search/suggest.json?q=${encodeURIComponent(qs)}&resources[type]=product&resources[limit]=10&resources[options][fields]=title&resources[options][unavailable_products]=hide`)
      .then(r=>r.ok?r.json():null).then(j=>(j&&j.resources&&j.resources.results&&j.resources.results.products)||[]).catch(()=>[]);
  }
  function cardHTML(p){
    let img=p.image||(p.featured_image&&p.featured_image.url)||"";
    if(img){img=(img.startsWith("//")?"https:"+img:img);img+=(img.includes("?")?"&":"?")+"width=360";}
    const url=String(p.url||("/products/"+p.handle)).split("?")[0];
    const price=Number(p.price);
    return `<a class="crack__card" href="${esc(url)}"><span class="crack__img">${img?`<img src="${esc(img)}" alt="" loading="lazy" width="360" height="360">`:""}</span><span class="crack__ptitle">${esc(p.title)}</span><span class="crack__price">${isNaN(price)?"":price.toFixed(2).replace(".",",")+" €"}</span></a>`;
  }
  const kitKey=t=>nrm(t).replace(/\s*(version|manga larga).*$/,"").trim();
  const rank=t=>{t=nrm(t);return /version fan/.test(t)?3:/version jugador/.test(t)?2:/nino|mujer/.test(t)?0:1};
  function pickKits(list,n,skip){const seen=new Set(skip||[]),out=[];
    for(const p of [...list].sort((a,b)=>rank(b.title)-rank(a.title))){const k=kitKey(p.title);if(seen.has(k))continue;seen.add(k);out.push(p);if(out.length>=n)break}
    return out}
  async function clubShirts(term){
    const must=nrm(term);
    const [cur,ret]=await Promise.all([searchShop(term+" fan"),searchShop("retro "+term)]);
    const all=[...cur,...ret].filter(p=>nrm(p.title).includes(must));
    const a=pickKits(all.filter(p=>!/retro/i.test(p.title)),2);
    const b=pickKits(all.filter(p=>/retro/i.test(p.title)),2);
    let out=[...a,...b];
    if(out.length<4) out=out.concat(pickKits(all,4-out.length,out.map(p=>kitKey(p.title))));
    return out;
  }
  async function natShirts(name){
    const must=nrm(name), r=await searchShop(name+" fan");
    const list=r.filter(p=>nrm(p.title).includes(must));
    const out=pickKits(list.filter(p=>!/retro/i.test(p.title)),2);
    return out.length<2?out.concat(pickKits(list,2-out.length,out.map(p=>kitKey(p.title)))):out;
  }
  function slot(title,promise){
    const gid="g"+Math.random().toString(36).slice(2,8);
    promise.then(list=>{const el=document.getElementById(gid);if(!el)return;
      if(!list.length){el.parentNode.remove();return}
      el.className="crack__grid"+(list.length<=2?" two":"");el.innerHTML=list.map(cardHTML).join("");});
    return `<div class="crack__relg"><h3 class="crack__relh">${esc(title)}</h3><div id="${gid}" class="crack__grid"><p class="crack__note">Buscando camisetas…</p></div></div>`;
  }
  function related(){
    const term=DATA.T[target.tm], nat=DATA.NS[target.nat];
    let h="";
    if(term) h+=slot(`Camisetas del ${target.tm}`,clubShirts(term));
    if(nat) h+=slot(`Con su selección: ${DATA.NN[target.nat]||nat}`,natShirts(nat));
    if(!h) h=slot("Te pueden gustar",searchShop("fan").then(l=>l.slice(0,4)));
    return h;
  }

  function openModal(){lastFocus=document.activeElement;renderModal();modal.hidden=false;document.documentElement.style.overflow="hidden";setTimeout(()=>$("[data-close]").focus(),30)}
  function closeModal(){modal.hidden=true;document.documentElement.style.overflow="";if(lastFocus&&lastFocus.focus)lastFocus.focus()}
  $("[data-close]").addEventListener("click",closeModal);
  modal.addEventListener("click",e=>{if(e.target===modal)closeModal()});
  document.addEventListener("keydown",e=>{if(e.key==="Escape"&&!modal.hidden)closeModal()});

  function renderModal(){
    let top;
    const J=window.CortitaJuegos;
    if(state.won&&mode==="daily"){
      top=`<p class="crack__meyebrow">Acertado en ${state.g.length} ${state.g.length===1?"intento":"intentos"}</p><h2 id="${ID}">¡Golazo! Era ${esc(target.n)}</h2>`+(J?J.prizeBox("crack",true):"");
    } else if(state.won){
      top=`<p class="crack__meyebrow">Partida de práctica</p><h2 id="${ID}">¡Bien visto! Era ${esc(target.n)}</h2><p>Las partidas de práctica no suman premio. El descuento es para el crack del día.</p>`;
    } else {
      top=`<p class="crack__meyebrow">6 intentos gastados</p><h2 id="${ID}">Esta vez no. Era ${esc(target.n)}</h2><p>${esc(target.tm)}, dorsal ${target.d}.</p>`+(mode==="daily"&&J?J.prizeBox("crack",false):"<p>Prueba otra partida o vuelve al crack del día.</p>");
    }
    mbody.innerHTML=top+(mode==="daily"?`<div class="crack__row"><button class="crack__btn crack__btn--ghost" type="button" data-share>Copiar resultado</button></div>`:"")+`<div class="crack__rel">${related()}</div>`;
    const sb=mbody.querySelector("[data-share]");
    if(sb) sb.addEventListener("click",()=>{const t=shareText();(navigator.clipboard?navigator.clipboard.writeText(t):Promise.reject()).then(()=>{sb.textContent="Copiado"}).catch(()=>{sb.textContent="No se pudo copiar"})});
  }
  function renderResult(){
    const R=$("[data-result]");
    if(!state.done){R.hidden=true;R.innerHTML="";return}
    R.hidden=false;
    const lbl=mode!=="daily"?"Ver resultado":"Ver resultado y premio";
    R.innerHTML=`<p>${state.won?`${mode==="daily"?"Hoy lo has clavado":"Acertado"}: <b>${esc(target.n)}</b>.`:`${mode==="daily"?"Hoy era":"Era"} <b>${esc(target.n)}</b>.`} ${mode==="daily"?"Vuelve mañana a por el siguiente.":""}</p><div class="crack__row"><button class="crack__btn" type="button" data-reopen>${lbl}</button>${mode!=="daily"?`<button class="crack__btn crack__btn--ghost" type="button" data-back>Volver al crack del día</button>`:""}</div>`;
    R.querySelector("[data-reopen]").addEventListener("click",openModal);
    const b=R.querySelector("[data-back]"); if(b) b.addEventListener("click",()=>{mode="daily";load();});
  }
  $("[data-practice]").addEventListener("click",()=>{
    mode="practice"; target=P[Math.floor(Math.random()*P.length)];
    state={g:[],done:false,won:false,claimed:false};
    render(); q.focus(); root.scrollIntoView({behavior:RM?"auto":"smooth"});
  });
  load();
})();
